import { FormControl, FormErrorMessage, Flex } from "@chakra-ui/react";
import { FormProvider, useForm } from "react-hook-form";
import { User, UserCenterRole } from "../../types/user.types";
import PrimaryButton from "../PrimaryButton";
import { useMutation } from "react-query";
import { updateUser } from "../../queries/user.queries";
import { Center } from "../../types/center.types";
import Select from "../inputs/Select";
import i18n from "../../i18n";
import { MutateErrors, mutateOnError } from "../../lib/generic";

type UserCenterFormProps = {
	user: User;
	center?: Center | null;
	onSuccess?: () => void;
};

function UserCenterForm({ user, center, onSuccess }: UserCenterFormProps) {
	const methods = useForm();
	const { mutate: mutateUpdateUser } = useMutation(updateUser, {
		onSuccess: () => {
			if (onSuccess) {
				onSuccess();
			}
		},
		onError: (err: MutateErrors) => {
			mutateOnError(err);
			err.response.data.errors.forEach((error) => {
				methods.setError(error.field, {
					message: error.message,
				});
			});
		},
	});

	const onSubmit = async () => {
		if (!center) {
			return;
		}
		const values = methods.getValues();
		mutateUpdateUser({
			id: user.id,
			centerId: center.id,
			role: values.role,
		});
	};

	return (
		<FormProvider {...methods}>
			<form style={{ marginTop: "32px", marginBottom: "32px" }}>
				<Flex direction="column" gap="24px">
					<FormControl isInvalid={!!methods.formState.errors.role}>
						<Select
							id="role"
							placeholder="Rôle"
							defaultValue={user.role}
							{...methods.register("role", {
								required: "Ce champ est obligatoire",
							})}
						>
							<option value={UserCenterRole.AUDIOPROSTHESIST}>
								{i18n.t(UserCenterRole.AUDIOPROSTHESIST)}
							</option>
							<option value={UserCenterRole.ASSISTANT}>
								{i18n.t(UserCenterRole.ASSISTANT)}
							</option>
							<option value={UserCenterRole.OTHER}>
								{i18n.t(UserCenterRole.OTHER)}
							</option>
						</Select>
						<FormErrorMessage>
							<>{methods.formState.errors?.role?.message}</>
						</FormErrorMessage>
					</FormControl>

					<PrimaryButton type="button" onClick={onSubmit}>
						Sauvegarder
					</PrimaryButton>
				</Flex>
			</form>
		</FormProvider>
	);
}

export default UserCenterForm;
